<template>
<b-container fluid>
    <b-row>
      <b-col cols="9">
        <GChart type="ColumnChart" :data="chartData" :options="chartOptions" class="my-2" />
      </b-col>
      <b-col>
        <p>Generate Shipped per Day Report Ending on:</p>
        <b-form-input type="date" v-model="chartEndDate" />
      </b-col>
    </b-row>
  <b-row v-for="datum in pickSums" :key="datum.state">
    {{datum.state}}: {{datum.count}}
  </b-row>
  <b-row>
    <h3><i>FIRST</i> Choice Backorder Summary as of {{loadTime.toLocaleTimeString()}}</h3>
  </b-row>
  <b-row>
    <b-col class="my-1">
      <b-input-group>
        <b-form-input v-model="filter" placeholder="Type to Search" />
        <b-input-group-append>
          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>
  </b-row>
  <b-row>
    <b-table :fields="fields" :items="items" :filter="filter" class="fixed-table">
      <template slot='partNum' slot-scope="data">
        <router-link
            :to="{ name: 'Qty Calculations', query: { partNum: data.item.partNum }}"
            target="_blank"
          >{{ data.item.partNum }}</router-link>
      </template>
      <template slot='soNums' slot-scope="data">
        <div v-if="data.item.soNums.split(',').length <= 10">
          <div v-for="num in uniq(data.item.soNums.split(','))" :key="num">
            <router-link
              :to="{ name: 'View Order', params: { id: num }}"
              target="_blank"
            >{{ num }}</router-link>
          </div>
        </div>
        <div v-else>
          <b-button v-b-toggle="`collapse-${data.item.partNum}`" variant="outline-primary">Show {{uniq(data.item.soNums.split(',')).length}} Orders</b-button>
          <b-collapse :id="`collapse-${data.item.partNum}`">
            <b-row style="max-width: 100%;">
              <b-col cols="6" md="4" xl="3" v-for="num in uniq(data.item.soNums.split(','))" :key="num">
                <router-link
                  :to="{ name: 'View Order', params: { id: num }}"
                  target="_blank"
                >{{ num }}</router-link>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
      </template>
      <template slot='estCanBuild' slot-scope="data">
        <div v-if="data.item.estCanBuild">{{data.item.estCanBuild}}</div>
        <div v-else>0</div>
      </template>
    </b-table>
  </b-row>
</b-container>
</template>

<script>
import axios from 'axios';
import { GChart } from 'vue-google-charts';
let BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    GChart,
  },
  data() {
    return {
      loadTime: new Date(),
      chartData: [],
      chartOptions: {
        title: 'FIRST Choice Orders Shipped by Day',
        subtitle: '(past 30 days)',
        hAxis: {
          title: 'Date',
        },
        vAxis: {
          title: 'Count',
        },
      },
      items: [],
      pickSums: [],
      chartEndDate: '',
      fields: [
        { key: 'partInfo', sortable: true },
        { key: 'partNum', label: 'Part Number', sortable: true },
        { key: 'partDescription', label: 'Description', sortable: true },
        { key: 'quantityNeeded', label: 'Allocated (includes picked)', sortable: true },
        { key: 'onHand', label: 'On Hand (includes picked)', sortable: true },
        { key: 'numShort', label: 'Short', sortable: true },
        { key: 'optionNote', sortable: true },
        { key: 'soNums', label: 'Orders (includes picked)', sortable: true },
        { key: 'ordernote', label: 'Part Ordering Notes in Fishbowl', sortable: true },
        { key: 'estCanBuild', sortable: true },
        { key: 'mosWithPart', label: 'On These MOs', sortable: true },
      ],
      filter: '',
    };
  },
  methods: {
    distinct(v, i, s) {
      return s.indexOf(v) == i;
    },
    uniq(arr) {
      return arr.filter(this.distinct);
    }
  },
  mounted() {
    this.chartEndDate = (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1) + '-' + (new Date()).getDate()
    axios.get(`${BASE_API}/fishbowl/reports/fc-backorder-summary`).then((response) => {
      // sort results by partInfo then partNum
      this.items = response.data.sort((a,b) => {
        var comp = a.partInfo.localeCompare(b.partInfo);
        if (!comp) comp = a.partNum.localeCompare(b.partNum);
        return comp;
      });
    })
    axios.get(`${BASE_API}/am-old-db/shipping/fc-amego-data`, {params: {endDate: this.chartEndDate}}).then((response) => {
      this.chartData = [['Day', 'Number of Orders', 'Number of Boxes']];
      response.data.forEach((data) => {
        this.chartData.push([new Date(`${data.sdateyear},${data.sdatemonth},${data.sdateday}`), data.numberordersshipped, data.numberboxes]);
      })
    })
    axios.get(`${BASE_API}/fishbowl/reports/backorder-pick-status?filter=CH`).then(response => {
      this.pickSums = response.data
    })
  },
  watch: {
    chartEndDate() {
      axios.get(`${BASE_API}/am-old-db/shipping/fc-amego-data`, {params: {endDate: this.chartEndDate}}).then((response) => {
        this.chartData = [['Day', 'Number of Orders', 'Number of Boxes']];
        response.data.forEach((data) => {
          this.chartData.push([new Date(`${data.sdateyear},${data.sdatemonth},${data.sdateday}`), data.numberordersshipped, data.numberboxes]);
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ops-info/FCOpsReport.vue